module.exports = __webpack_public_path__ + "img/title.7fd0829e.jpg";